export const SLICE_NAME_FILTER = 'filters'
